// extracted by mini-css-extract-plugin
export default {"ForgotPass":"Account_ForgotPass__yDtqz"};